import {
  transactionPutError,
  transactionPutStart,
  transactionPutSuccess,
  withdrawStart,
  withdrawSuccess,
  withdrawError,
} from "../actions/transactions";
import ActionManager from "./base";

import transactionsAPI from "../api/transactions";
import DefaultActionManager from "./default_action_manager";

export const getTransactionForUserActionName = "GET_TRANSACTION_FOR_USER_ACTION_NAME";

export class TransactionPutActionManager extends ActionManager {
  defaultErrorMessage() {
    return "Uh oh, something went wrong charging your card. Please try again later.";
  }

  defaultPreCallActionCreator() {
    return transactionPutStart;
  }

  defaultSuccessActionCreator() {
    return transactionPutSuccess;
  }

  defaultErrorActionCreator() {
    return transactionPutError;
  }

  execute() {
    return transactionsAPI.addFunds(this.args.user, this.args.amount, this.args.stripeToken);
  }

  responseOK(dispatch, json) {
    super.responseOK(dispatch, json);
    this.showSuccess(dispatch, "Charge successful! Funds are added to your account.");
  }
}

export const getTransactionsForUser = () =>
  new DefaultActionManager({
    route: "transactions",
    auth: true,
    actionName: getTransactionForUserActionName,
  }).run();

export class TransactionWithdrawActionManager extends ActionManager {
  defaultErrorMessage() {
    return "Uh oh, something went wrong with cashing out. Please try again later.";
  }

  execute() {
    return transactionsAPI.withdrawFunds(this.args.user);
  }

  defaultPreCallActionCreator() {
    return withdrawStart;
  }

  defaultSuccessActionCreator() {
    return withdrawSuccess;
  }

  defaultErrorActionCreator() {
    return withdrawError;
  }

  responseOK(dispatch, json) {
    super.responseOK(dispatch, json);
    this.showSuccess(
      dispatch,
      "Success! You should see the money in your bank account in the next day or two."
    );
  }
}
